import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";


export async function renderBooleanFieldWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // Container
    const container = context.document.createElement("div");
    container.classList.add("widget", "form_field_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    applyFieldStyles(styles, device);
    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(container);

    // Checkbox visual
    const inputEl = renderInput(context, device);
    container.appendChild(inputEl);

    // Label
    const labelEl = renderLabel(context, widget, device);
    if (labelEl) container.appendChild(labelEl);

    return container;
}

function renderInput(context, device) {
    const el = context.document.createElement("div");
    el.classList.add("boolean-checkbox");

    if (device.placeholder) {
        el.innerHTML = device.placeholder;
    }

    el.setAttribute("style", cssUtil.toStyleString({}));
    return el;
}

function renderLabel(context, widget, device) {
    let label = device.label;

    // Backend field lookup removed (HTML-only)
    // Fallback to widget.content if available
    if (!label && widget.content) {
        label = widget.content;
    }

    if (!label) return null;

    const el = context.document.createElement("span");
    el.innerHTML = label;

    const styles = {};
    applyLabelStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function applyFieldStyles(styles, device) {
    const alignment = device.styles?.layout?.alignment;
    if (alignment) {
        styles["text-align"] = alignment;
    }
}

function applyLabelStyles(styles, device) {
    const layout = device.styles?.layout;
    const regular = device.styles?.regular;
    if (!layout || !regular) return;

    const alignment = layout.alignment;
    const fieldSpacing = layout.fieldSpacing;
    const labelPadding = layout.labelPadding;
    const inputPadding = layout.inputPadding;

    if (fieldSpacing) {
        styles["padding-bottom"] = `${fieldSpacing}px`;
    }

    if (labelPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${inputPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${labelPadding}px`;
        }
    }

    // Placeholder / label color
    const colorProp = regular.input?.placeholderColor;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }

    styles["vertical-align"] = "bottom";

    applyFontStyles(styles, regular.input);
}

function applyFontStyles(styles, fontStyle) {
    if (!fontStyle?.font) return;

    const font = fontStyle.font;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;
}
